var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"shadow":"hover"}},[_c('label',{attrs:{"slot":"header"},slot:"header"},[_vm._v("头像-重置密码-退出登录")]),_c('el-divider',{attrs:{"content-position":"left"}},[_vm._v("j-avatar")]),_c('div',{staticStyle:{"width":"150px"}},[_c('j-avatar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }